<div id="arc_help">

    <div class="header_container">
      <span class="title">How do I correct my scoring factors?</span>
      <div (click)="activeModal.close()">
        <i class="fa cancel fa-times"></i>
      </div>
    </div>
  
    <div class="p2535">
      <p>
        Arc Certificates are subject to a battery of automated tests to evaluate the integrity of the underlying performance information. To be valid, each project must pass the following five tests. Data must be:
      </p>
      <br>
      <p>
      <h4>Complete</h4>
      <p>
        Information is provided for the entire performance period (12 months for Performance Score and 24 months for Improvement Score
      </p>
      <br>
      <p class="error-color">
        How to Fix This:
      </p>
      <p>
        • Change your performance period dates.
      </p>
      <br>
      <br>
      <p>
      <h4>Timely</h4>
      <p>
        Data must be recent. For Arc Performance Certificates, this means that data must be submitted within 12 months (ie. the end of the performance period is a maximum of 12 months from the current date)
      </p>
      <br>
      <p class="error-color">
        How to Fix This:
      </p>
      <p>
        • Update your data
      </p>
      <br>
      <br>
      <p>
      <h4>Check for Outliers</h4>
      <p>
        Information falls within a reasonable range based on the project type and circumstances. This is Initially defined as values less than 99 percent of the maximum value observed in the reference set and more than 1 percent of minimum value observed in the reference set.
      </p>
      <br>
      <p class="error-color">
        How to Fix This:
      </p>
      <p>
        • Update your data
      </p>
      <br>
      <br>
    </div>